<template>
  <div class="app-container">
    <el-tabs v-model="activeName" type="border-card" @tab-click="changeTab">
      <el-tab-pane label="操作日志" name="operateLog">
        <!-- <el-row class="top-operate">
            <el-col :span="12">
              <deBtn v-permission="['log:export']" secondary @click="exportConfirm">{{
                $t("zip.export")
              }}</deBtn>
              &nbsp; &nbsp;
            </el-col>
            <el-col :span="12" class="right-user">
              <el-input ref="search" v-model="nickName" :placeholder="$t('system_parameter_setting.by_event_details')"
                prefix-icon="el-icon-search" class="name-email-search" size="small" clearable @blur="initSearch"
                @clear="initSearch" />
              <deBtn :secondary="!cacheCondition.length" :plain="!!cacheCondition.length" icon="iconfont icon-icon-filter"
                @click="filterShow">{{ $t("user.filter")
                }}<template v-if="filterTexts.length">
                  ({{ cacheCondition.length }})
                </template>
              </deBtn>
            </el-col>
          </el-row> -->
        <el-form :model="queryParams" ref="schoolForm" :inline="true" size="mini" class="box_form">
          <el-form-item label="操作用户:" prop="headline">
            <el-input v-model="queryParams.headline" placeholder="操作用户" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
          <el-form-item label="所属模块:" prop="newsType">
            <el-select v-model="queryParams.newsType" placeholder="所属模块" clearable :popper-append-to-body="true">
              <el-option v-for="(item, index) in newsType" :key="index" :label="item.name" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="操作类型:" prop="actState">
            <el-select v-model="queryParams.isEnable" placeholder="操作类型" clearable :popper-append-to-body="true">
              <el-option v-for="(item, index) in actStatus" :key="index" :label="item.name" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="操作时间:" prop="time">
            <el-date-picker v-model="queryParams.time" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']" range-separator="-" start-placeholder="开始时间"
              end-placeholder="结束时间">
            </el-date-picker>
          </el-form-item>
          <div>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询
              </el-button>
              <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
              <el-button type="" icon="el-icon-download" size="mini" @click="exportConfirm">导出数据
              </el-button>
            </el-form-item>
          </div>
        </el-form>

        <div v-if="filterTexts.length" class="filter-texts">
          <span class="sum">{{ paginationConfig.total }}</span>
          <span class="title">{{ $t("user.result_one") }}</span>
          <el-divider direction="vertical" />
          <i v-if="showScroll" class="el-icon-arrow-left arrow-filter" @click="scrollPre" />
          <div class="filter-texts-container">
            <p v-for="(ele, index) in filterTexts" :key="ele" class="text">
              {{ ele }}
              <i class="el-icon-close" @click="clearOneFilter(index)" />
            </p>
          </div>
          <i v-if="showScroll" class="el-icon-arrow-right arrow-filter" @click="scrollNext" />
          <el-button type="text" class="clear-btn" icon="el-icon-delete" @click="clearFilter">{{ $t("user.clear_filter")
            }}</el-button>
        </div>

        <div id="resize-for-filter" class="table-container"
          :class="[filterTexts.length ? 'table-container-filter' : '']">
          <grid-table v-loading="$store.getters.loadingMap[$store.getters.currentPath]" :table-data="data" :columns="[]"
            :pagination="paginationConfig" @sort-change="sortChange" @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
            <el-table-column show-overflow-tooltip prop="opType" :label="$t('log.optype')" width="160">
              <template #default="{ row }">
                <span>{{ row.opType + row.sourceType }}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="detail" :label="$t('log.detail')" />
            <el-table-column show-overflow-tooltip prop="user" :label="$t('log.user')" width="100" />
            <el-table-column show-overflow-tooltip prop="ip" :label="$t('log.ip')" width="100" />
            <el-table-column show-overflow-tooltip prop="time" sortable="custom" :label="$t('log.time')" width="180">
              <template #default="scope">
                <span>{{ scope.row.time | timestampFormatDate }}</span>
              </template>
            </el-table-column>
          </grid-table>
        </div>

        <keep-alive>
          <filterUser ref="filterUser" @search="filterDraw" />
        </keep-alive>
      </el-tab-pane>

      <el-tab-pane label="登录日志" name="loginLog">
        <el-form :model="queryParamsLogin" ref="queryLoginForm" :inline="true" size="mini" class="box_form">
          <el-form-item label="登录用户:" prop="userPhone">
            <el-input v-model="queryParamsLogin.userPhone" placeholder="请输入用户手机号码" clearable
              @keyup.enter.native="handleQueryLogin" />
          </el-form-item>
          <el-form-item label="访问时间:" prop="time">
            <el-date-picker v-model="queryParamsLogin.time" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']" range-separator="-" start-placeholder="选择日期"
              end-placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <div>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQueryLogin">查询
              </el-button>
              <el-button icon="el-icon-refresh-left" size="mini" @click="resetQueryLogin">重置</el-button>
              <!-- <el-button type="" icon="el-icon-download" size="mini" @click="exportConfirmLogin">导出数据</el-button> -->
            </el-form-item>
          </div>
        </el-form>
        <el-table :data="tableDataLogin" v-loading="loading" element-loading-text="加载中">
          <el-table-column label="序号" type="index"></el-table-column>
          <el-table-column prop="userPhone" label="登录用户"></el-table-column>
          <el-table-column prop="loginIp" label="登录IP"></el-table-column>
          <el-table-column prop="loginStatus" label="登录状态">
            <template slot-scope="scope">
              <span class="loginSut1" v-if="scope.row.loginStatus == 1">
                成功
              </span>
              <span v-else> 失败 </span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="访问时间">
            <template slot-scope="scope">
              {{ scope.row.createTime | timestampFormatDate }}
            </template>
          </el-table-column>
        </el-table>
        <pagination :total="queryParamsLogin.total" :page.sync="queryParamsLogin.pageNum"
          :limit.sync="queryParamsLogin.pageSize" @pagination="getDataLogin" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import GridTable from "@/components/gridTable/index.vue";
import filterUser from "./FilterUser";
import _ from "lodash";
import keyEnter from "@/components/msgCfm/keyEnter.js";
import { buildParam } from "@/utils/GridConditionUtil";
import { addOrder, formatOrders } from "@/utils/index";
import moment from "moment";
// import * as API_Log from "@/api/system/log";
import { logGrid, exportExcel, loginTraceList } from "@/api/system/log";
export default {
  components: { GridTable, filterUser },
  mixins: [keyEnter],
  data() {
    return {
      // new-start
      activeName: "operateLog",
      queryParams: {},
      loading: false,
      // new-end

      columns: [],
      paginationConfig: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      data: [],
      orderConditions: [],
      nickName: "",
      showScroll: false,
      filterTexts: [],
      cacheCondition: [],

      // 登录日志

      queryParamsLogin: {
        userPhone: null,
        time: null,
        startTime: null,
        endTime: null,
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      tableDataLogin: [],
    };
  },
  watch: {
    filterTexts: {
      handler() {
        this.getScrollStatus();
      },
      deep: true,
    },
  },
  mounted() {
    this.search();
    this.resizeObserver();
  },
  created() {
    // this.getLoginData()
  },
  methods: {
    handleQuery() {
      console.log(this.queryParams);
      this.search();
    },
    changeTab(e) {
      console.log(e);
      if (e.name == "operateLog") {
        this.search();
      } else if (e.name == "loginLog") {
        this.resetQueryLogin();
      }
    },

    // 登录-tab-start
    handleQueryLogin() {
      this.queryParamsLogin.startTime = this.queryParamsLogin.time
        ? moment(this.queryParamsLogin.time[0]).valueOf()
        : null;
      this.queryParamsLogin.endTime = this.queryParamsLogin.time
        ? moment(this.queryParamsLogin.time[1]).valueOf()
        : null;
      console.log(this.queryParamsLogin);
      this.queryParamsLogin.pageNum = 1;
      this.getDataLogin();
    },

    resetQueryLogin() {
      this.queryParamsLogin.startTime = "";
      this.queryParamsLogin.endTime = "";
      this.$refs["queryLoginForm"].resetFields();
      this.getDataLogin();
    },

    getDataLogin() {
      this.loading = true;
      let loginTraceQueryDTO = this.queryParamsLogin;
      loginTraceList(loginTraceQueryDTO).then((response) => {
        let data = response.data || [];
        this.queryParamsLogin.total = data.total;
        this.tableDataLogin = data.list;
        setTimeout(() => {
          this.loading = false;
        }, 500);
      });
    },
    // 登录-tab-end

    exportConfirm() {
      this.$confirm(this.$t("log.confirm"), "", {
        confirmButtonText: this.$t("commons.confirm"),
        cancelButtonText: this.$t("commons.cancel"),
        type: "warning",
      })
        .then(() => {
          this.exportData();
        })
        .catch(() => {
          // this.$info(this.$t('commons.delete_cancel'))
        });
    },

    exportData() {
      const param = buildParam(this.cacheCondition, this.nickName);
      param.orders = formatOrders(this.orderConditions);

      exportExcel(param).then((res) => {
        const blob = new Blob([res], { type: "application/vnd.ms-excel" });
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        link.download = "DataEase操作日志.xlsx"; // 下载的文件名
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },

    sortChange({ column, prop, order }) {
      this.orderConditions = [];
      if (!order) {
        this.initSearch();
        return;
      }

      this.orderConditions = [];
      addOrder({ field: prop, value: order }, this.orderConditions);
      this.initSearch();
    },
    getScrollStatus() {
      this.$nextTick(() => {
        const dom = document.querySelector(".filter-texts-container");
        this.showScroll = dom && dom.scrollWidth > dom.offsetWidth;
      });
    },
    resizeObserver() {
      this.resizeForFilter = new ResizeObserver((entries) => {
        if (!this.filterTexts.length) return;
        this.layoutResize();
      });
      this.resizeForFilter.observe(
        document.querySelector("#resize-for-filter"),
      );
    },
    layoutResize: _.debounce(function () {
      this.getScrollStatus();
    }, 200),
    scrollPre() {
      const dom = document.querySelector(".filter-texts-container");
      dom.scrollLeft -= 10;
      if (dom.scrollLeft <= 0) {
        dom.scrollLeft = 0;
      }
    },
    scrollNext() {
      const dom = document.querySelector(".filter-texts-container");
      dom.scrollLeft += 10;
      const width = dom.scrollWidth - dom.offsetWidth;
      if (dom.scrollLeft > width) {
        dom.scrollLeft = width;
      }
    },
    handleSizeChange(pageSize) {
      this.paginationConfig.currentPage = 1;
      this.paginationConfig.pageSize = pageSize;
      this.search();
    },
    handleCurrentChange(currentPage) {
      this.paginationConfig.currentPage = currentPage;
      this.search();
    },
    initSearch() {
      this.handleCurrentChange(1);
    },
    clearFilter() {
      this.$refs.filterUser.clearFilter();
    },
    clearOneFilter(index) {
      this.$refs.filterUser.clearOneFilter(index);
      this.$refs.filterUser.search();
    },
    filterDraw(condition, filterTexts = []) {
      this.cacheCondition = condition;
      this.filterTexts = filterTexts;
      this.initSearch();
    },
    filterShow() {
      this.$refs.filterUser.init();
    },
    search() {
      const param = buildParam(this.cacheCondition, this.nickName);
      param.orders = formatOrders(this.orderConditions);
      param.logGridRequest = {
        ...this.queryParams,
      };

      const { currentPage, pageSize } = this.paginationConfig;

      logGrid(currentPage, pageSize, param).then((response) => {
        this.data = response.data.listObject;
        this.paginationConfig.total = response.data.itemCount;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.table-container {
  height: 550px;
}

.loginSut1 {
  color: #67c23a;
}

// .table-container-filter {
//   height: calc(100% - 110px);
// }
</style>
